import { useEffect, useState, useRef } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Save, Move } from "lucide-react";

export default function IDGExternalWidgetsTab() {
  const [widgets, setWidgets] = useState([]);
  const [loading, setLoading] = useState(false);
  const sortableRef = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/admin/api/idg-widgets");
      setWidgets(data.widgets || []);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (window.IDGUI && window.IDGUI.sortable && sortableRef.current && widgets.length > 0) {
      window.IDGUI.sortable(sortableRef.current, {
        handle: ".idg-drag-handle",
        onEnd: async () => {
          const items = Array.from(sortableRef.current.children);
          const newOrder = items.map((el, i) => ({
            blockKey: el.dataset.key,
            position: i
          }));
          try {
            await api.post("/admin/api/idg-widgets/order", newOrder);
            toast.success("Ordine salvată!");
            load();
          } catch (e) {
            toast.error("Eroare la salvarea ordinii");
          }
        }
      });
    }
  }, [widgets.length]); // Re-bind if count changes, or just let IDGUI handle mutations

  const handleSave = async (w) => {
    try {
      await api.post("/admin/api/idg-widgets/save", w);
      toast.success("Widget salvat!");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const handleAdd = () => {
    const key = prompt("Cheie widget (ex: latest_topics):");
    if (!key) return;
    const newW = {
      blockKey: key,
      title: "Widget Nou",
      type: "html",
      content: "<p>Conținut widget</p>",
      area: "sidebar",
      position: widgets.length,
      active: true
    };
    handleSave(newW);
  };

  const toggleActive = (w) => {
    handleSave({ ...w, active: !w.active });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="tf-section-title">IDG External Widgets</h2>
        <button onClick={handleAdd} className="idg-btn idg-btn-cyan">
          <Plus className="w-4 h-4" /> Adaugă Widget
        </button>
      </div>

      <div className="idg-table-wrapper">
        <table className="idg-table w-full text-left">
          <thead>
            <tr>
              <th className="w-10"></th>
              <th>Cheie</th>
              <th>Titlu</th>
              <th>Tip</th>
              <th>Status</th>
              <th className="text-right">Acțiuni</th>
            </tr>
          </thead>
          <tbody ref={sortableRef}>
            {widgets.map((w) => (
              <tr key={w.blockKey} data-key={w.blockKey} className="idg-table-row">
                <td className="w-10 text-center text-gray-500 cursor-move idg-drag-handle hover:text-white">
                  <Move className="w-4 h-4 inline-block" />
                </td>
                <td className="font-mono text-xs">{w.blockKey}</td>
                <td>{w.title}</td>
                <td><span className="idg-badge idg-badge-cyan">{w.type}</span></td>
                <td>
                  <button onClick={() => toggleActive(w)} className={`idg-badge ${w.active ? 'idg-badge-green' : 'bg-red-500/20 text-red-400'}`}>
                    {w.active ? 'Activ' : 'Inactiv'}
                  </button>
                </td>
                <td className="text-right space-x-2">
                  <button onClick={() => {
                    const newTitle = prompt("Titlu nou:", w.title);
                    if (newTitle) handleSave({ ...w, title: newTitle });
                  }} className="text-xs text-[var(--idg-cyan)] hover:underline">Editează</button>
                </td>
              </tr>
            ))}
            {widgets.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center py-8 text-gray-500">Niciun widget definit.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
